import { ApiError } from '@/api/client';

interface Props {
  error: unknown;
  onRetry?: () => void;
}

export default function ErrorBanner({ error, onRetry }: Props) {
  const message =
    error instanceof ApiError
      ? `${error.status} — ${error.message}`
      : error instanceof Error
        ? error.message
        : 'Unknown error';
  return (
    <div className="error-banner" role="alert">
      <span>⚠️ {message}</span>
      {onRetry ? (
        <button className="btn btn-ghost" onClick={onRetry}>
          Retry
        </button>
      ) : null}
    </div>
  );
}
